import { Dispatch, SetStateAction } from "react";
import { Profile } from "../ProfileSettings/types";

export type SocialMediaLinks = {
  websiteLink: string;
  instagramLink: string;
  spotifyLink: string;
  soundCloudLink: string;
};

export interface SocialMediaLinksFormProps {
  links: SocialMediaLinks;
  setLinks: Dispatch<SetStateAction<SocialMediaLinks>>;
  affiliation: Affiliation;
  setAffiliation: React.Dispatch<React.SetStateAction<Affiliation>>
}

export interface ProfileDetailsFormProps {
  genreList: string[];
  setGenreList: React.Dispatch<React.SetStateAction<string[]>>;
  profilePicture: React.MutableRefObject<HTMLInputElement | null>;
  setProfilePic: React.Dispatch<React.SetStateAction<string | null>>;
  setProfilePicBlob: React.Dispatch<React.SetStateAction<Blob | null>>;
  setProfilePicFile: React.Dispatch<React.SetStateAction<File | null>>;
  profilePic: string | null;
  links: SocialMediaLinks;
  setLinks: React.Dispatch<React.SetStateAction<SocialMediaLinks>>;
  isSubmitting: boolean;
  handleSaveChanges: () => Promise<void>;
  affiliation: Affiliation;
  setAffiliation: React.Dispatch<React.SetStateAction<Affiliation>>
}

export interface UserProfileFormProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  profile: Profile;
  usedStorage: number;
  skillList: string[];
  setSkillList: React.Dispatch<React.SetStateAction<string[]>>;
}

export interface Affiliation {
  ASCAP: string;
  BMI: string;
  SESCAP: string;
}

export const InitialAffiliation = {
  ASCAP: "",
  BMI: "",
  SESCAP: "",
};